var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import moment from "moment";
import { CalendarOverlay } from "./calenderoverlay";
import { bind } from "decko";
import { GenericInputElement } from "./genericinputfield";
import Button from "./button";
import { css, cx } from "emotion";
const inputToggleClass = css({
    position: "relative",
});
const overlayToggleClass = css({
    position: "absolute",
    right: 0,
    top: 0,
    padding: "5px 10px",
});
const overlayToggleSmallClass = css({
    position: "absolute",
    right: 0,
    top: 0,
    padding: "2px 10px",
});
export class LocalDatePicker extends GenericInputElement {
    constructor(props) {
        super(props);
        this.validators.push(this.createDateValidator());
        this.state = Object.assign(Object.assign({}, this.defaultState), { showCalendar: false });
    }
    createDateValidator() {
        return (value) => {
            const m = moment(value, "YYYY-MM-DD", true);
            return {
                valid: m.isValid(),
                validationMessage: this.translate.validation.date.formatMismatch(this.props.format),
            };
        };
    }
    handleChange(value) {
        this.setState({ isPristine: false, showCalendar: false });
        const m = moment(value, this.props.format, true);
        const saveDate = m.isValid() ? m.format("YYYY-MM-DD") : value;
        this.props.onValueChange &&
            this.props.onValueChange(saveDate, this.validate(saveDate).length === 0);
    }
    toggleCalendar() {
        this.setState({
            showCalendar: !this.state.showCalendar,
        });
    }
    focusInputRef() {
        if (this.inputElRef) {
            this.inputElRef.focus();
        }
    }
    renderInner() {
        const m = moment(this.props.value, "YYYY-MM-DD", true);
        const displayDate = m.isValid()
            ? m.format(this.props.format)
            : this.props.value;
        return (React.createElement("div", { className: cx(inputToggleClass) },
            React.createElement("input", { ref: (el) => (this.inputElRef = el), type: "text", autoFocus: this.props.autoFocus, value: displayDate, placeholder: this.props.format, required: this.props.required, disabled: this.props.disabled, onBlur: this.defaultHandleFocus, onChange: (event) => this.handleChange(event.target.value), onFocus: this.defaultHandleFocus, onKeyDown: this.props.onKeyDown, tabIndex: this.props.tabIndex }),
            this.props.showPicker && (React.createElement("div", { className: cx(this.props.size === "small"
                    ? overlayToggleSmallClass
                    : overlayToggleClass) },
                React.createElement(Button, { formType: "button", type: "tertiary", size: this.props.size === "small" ? "tiny" : "normal", icon: "event_note", onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        this.toggleCalendar();
                    } }))),
            this.state.showCalendar && (React.createElement(CalendarOverlay, { value: m.toDate(), onClose: this.toggleCalendar, onUpdate: (value) => {
                    this.handleChange(moment(value).format(this.props.format));
                    this.focusInputRef();
                } }))));
    }
}
LocalDatePicker.defaultProps = {
    showPicker: true,
};
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LocalDatePicker.prototype, "handleChange", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LocalDatePicker.prototype, "toggleCalendar", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LocalDatePicker.prototype, "focusInputRef", null);
export default LocalDatePicker;
//# sourceMappingURL=localdatepicker.js.map